module.exports = __webpack_public_path__ + "assets/d730b3fe9bef13fb8407907217db94f5.png";